import {inject, Injectable} from '@angular/core';
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {BaseDesignBlockPathStateService} from "./base-design-block-path-state.service";
import {CreateDesignBlockData, DesignBlockData} from "../types/base-design-block.types";

@Injectable({
  providedIn: 'root'
})
export class BaseDesignBlockModalService {
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private baseDesignBlockPathStateService: BaseDesignBlockPathStateService = inject(BaseDesignBlockPathStateService);

  public setDataInModalParams(parentId: number): GetDataInModalParams {
    return {
      path: this.baseDesignBlockPathStateService.pathState(),
      queryParams: { designBlockId: parentId }
    };
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createData(createDesignBlockData: CreateDesignBlockData): Promise<DesignBlockData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateDesignBlockData, DesignBlockData>(createDesignBlockData, this.baseDesignBlockPathStateService.pathState()).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public deleteRecord(recordId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.deleteRecord(this.baseDesignBlockPathStateService.pathState(), recordId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
